import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RenderFilterForm from "../../utils/filterForm";
import {loadJobsForSelect, reset as resetJobsForSelect} from "../../actions/Job/forSelect";
import {loadTeamsForSelect} from "../../actions/Team/forSelect";
import {loadIndustriesForSelect} from "../../actions/Industry/forSelect";
import {loadOccupationsForSelect} from "../../actions/Occupation/forSelect";
import {loadSpecialtiesForSelect} from "../../actions/Specialty/forSelect";
import {loadCompanyUsersForSelect} from "../../actions/CompanyUser/forSelect";

class FilterForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    error: PropTypes.string
  };

  state = {
    industry:  null,
    occupation: null,
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.initialValues !== this.props.initialValues) {
      const values = nextProps.initialValues;
      this.setState({
        industry: null !== values && ('job___professionMappings___industry' in values) ? values['job___professionMappings___industry'] : null,
        occupation: null !== values && ('job___professionMappings___occupation' in values) ? values['job___professionMappings___occupation'] : null,
      });
    }
  }

  handleIndustrySelect = (e, value, oldValue) => {
    if (value !== oldValue) {
      this.props.change('job___professionMappings___occupation', null);
      this.props.change('job___professionMappings___specialty', null);

      this.setState({
        industry: value,
        occupation: null,
      });
    }
  };

  handleOccupationSelect = (e, value, oldValue) => {
    if (value !== oldValue) {
      this.props.change('job___professionMappings___specialty', null);

      this.setState({occupation: value});
    }
  };

  onFirstExpand = () => {
    this.props.loadJobsForSelect();
  }

  componentWillUnmount() {
    this.props.resetEntities();
  }

  constructor(props) {
    super(props);

    this.state = {
      jobsFilterIsModalOpen: false,
    }
  }

  jobsFilterToggleModal = (opened) => {
    this.setState({jobsFilterIsModalOpen: opened});
  }

  selectJob = (job, fieldName = '@id') => {
    this.props.change('job', job[fieldName]);
    this.jobsFilterToggleModal(false);
  }

  render() {
    let industryPlaceholder = this.props.industriesLoading ? 'Loading...' : 'Job Industry';
    let occupationPlaceholder = this.props.occupationsLoading ? 'Loading...' : 'Select Industry First';
    let specialtyPlaceholder = this.props.specialtiesLoading ? 'Loading...' : 'Select Occupation First';
    let teamPlaceholder = this.props.teamsLoading ? 'Loading...' : 'Team';
    let jobPlaceholder = this.props.jobsLoading ? 'Loading...' : 'Job';
    let companyUserPlaceholder = this.props.companyUsersLoading ? 'Loading...' : 'Posted By';

    let occupationOptions = [];
    let specialtyOptions = [];

    if (this.state.industry) {
      occupationPlaceholder = 'Job Occupation';
      if (this.props.occupations) {
        this.props.occupations.map(occupation => {
          if (occupation.industry === this.state.industry) {
            occupationOptions.push(occupation);
          }
        });
      }
    }
    if (this.state.occupation) {
      specialtyPlaceholder = 'Job Specialty';
      if (this.props.specialties) {
        this.props.specialties.map(specialty => {
          if (specialty.occupation === this.state.occupation) {
            specialtyOptions.push(specialty);
          }
        });
      }
    }

    return (
      <>
        {!this.props.parentLoading && this.props.loading && (
          <div className="alert alert-info">Loading...</div>
        )}
        <RenderFilterForm {...this.props} onFirstExpand={this.onFirstExpand} fields={[
          {'name': 'id', 'label': 'ID', 'placeholder': 'ID', 'type': 'number'},
          {'name': 'title', 'label': 'Title', 'placeholder': 'Title', 'type': 'text'},
          {'name': 'job___team', 'label': 'Team', 'placeholder': teamPlaceholder, 'type': 'selectSearch', 'options': this.props.teams},
          {'name': 'job', 'label': 'Job', 'placeholder': jobPlaceholder, 'type': 'jobSelectSearch', 'options': this.props.jobs,
            'jobsFilterSelectJob': this.selectJob,
            'jobsFilterToggleModal': this.jobsFilterToggleModal,
            'jobsFilterIsModalOpen': this.state.jobsFilterIsModalOpen,
          },
          {'name': 'job___professionMappings___industry', 'label': 'Job Industry', 'placeholder': industryPlaceholder, 'type': 'selectSearch', 'onChange': this.handleIndustrySelect, 'options': this.props.industries},
          {'name': 'job___professionMappings___occupation', 'label': 'Job Occupation', 'placeholder': occupationPlaceholder, 'type': 'selectSearch', 'isDisabled': !this.state.industry, 'onChange': this.handleOccupationSelect, 'options': occupationOptions},
          {'name': 'job___professionMappings___specialty', 'label': 'Job Specialty', 'placeholder': specialtyPlaceholder, 'type': 'selectSearch', 'isDisabled': !this.state.occupation, 'options': specialtyOptions},
          {'name': 'companyUser', 'label': 'Posted By', 'placeholder': companyUserPlaceholder, 'type': 'selectSearch', 'options': this.props.companyUsers},
          {'name': 'createdAt', 'label': 'Created Date', 'placeholder': 'Created Date', 'type': 'datesRange', 'past': true},
        ]} />
      </>
    );
  }
}

const mapStateToProps = state => {
  let teams = state.team.forSelect.retrieved;
  let jobs = state.job.forSelect.retrieved;
  let industries = state.industry.forSelect.retrieved;
  let occupations = state.occupation.forSelect.retrieved;
  let specialties = state.specialty.forSelect.retrieved;
  let companyUsers = state.companyUser.forSelect.retrieved;
  let loading = state.team.forSelect.loading || state.job.forSelect.loading || state.industry.forSelect.loading || state.occupation.forSelect.loading || state.occupation.forSelect.loading || state.specialty.forSelect.loading || state.companyUser.forSelect.loading;

  let teamsLoading = state.team.forSelect.loading;
  let jobsLoading = state.job.forSelect.loading;
  let industriesLoading = state.industry.forSelect.loading;
  let occupationsLoading = state.occupation.forSelect.loading;
  let specialtiesLoading = state.specialty.forSelect.loading;
  let companyUsersLoading = state.companyUser.forSelect.loading;

  return {
    teams,
    jobs,
    industries,
    occupations,
    specialties,
    companyUsers,
    loading,
    teamsLoading,
    jobsLoading,
    industriesLoading,
    occupationsLoading,
    specialtiesLoading,
    companyUsersLoading
  };
};

const mapDispatchToProps = dispatch => ({
  loadTeamsForSelect: () => dispatch(loadTeamsForSelect()),
  loadJobsForSelect: () => dispatch(loadJobsForSelect()),
  loadIndustriesForSelect: () => dispatch(loadIndustriesForSelect('@id')),
  loadOccupationsForSelect: () => dispatch(loadOccupationsForSelect('@id')),
  loadSpecialtiesForSelect: () => dispatch(loadSpecialtiesForSelect('@id')),
  loadCompanyUsersForSelect: () => dispatch(loadCompanyUsersForSelect()),
  resetEntities: () => {
    dispatch(resetJobsForSelect());
  },
});

FilterForm = reduxForm({
  form: 'filter_company_request',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(FilterForm);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterForm);
